module.exports = __webpack_public_path__ + "img/l_da.772ea4fb.png";